import { Reducer } from 'redux';
import { HttpRequestStatus } from '../../../model/enums/httpRequestStatus';
import { ProgramSimulationExampleActionTypes, ProgramSimulationExampleState } from './types';

export const initialState: ProgramSimulationExampleState = {
  status: HttpRequestStatus.NOOP,
  example: undefined,
  error: undefined
};

const reducer: Reducer<ProgramSimulationExampleState> = (state = initialState, action): ProgramSimulationExampleState => {
  switch (action.type) {
    case ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_REQUEST: {
      return { ...state, status: HttpRequestStatus.ON_GOING, example: undefined, error: undefined };
    }
    case ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_SUCCESS: {
      return { ...state, status: HttpRequestStatus.SUCCESS, example: action.payload, error: undefined };
    }
    case ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_ERROR: {
      return { ...state, status: HttpRequestStatus.ERROR, error: action.payload }
    }
    case ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_RESET_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export { reducer as programSimulationExampleReducer };

